import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import HeadComponent from "../components/HeadComponent/HeadComponent";
import dynamic from "next/dynamic";
import CustomSkeleton from "../components/CustomSkeleton/CustomSkeleton";
import FivaLayout from "../Layout/FivaLayout";
var DynamicComponent = dynamic(function() {
    return import("../components/_HomeComponents/HomePage");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("../components/_HomeComponents/HomePage")
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ _jsx(CustomSkeleton, {});
    }
});
var HomePage = function(param) {
    var data = param.data;
    var headerProps = {
        title: "Ahorra con Fiva | Compara entre +90 Tarifas de Luz",
        keywords: "Comparador, Comparador Luz y gas, Comparador Luz, electricidad baratas, el\xe9ctricas baratas, el\xe9ctricas baratas, Asesor\xeda energ\xe9tica, Consultor\xeda energ\xe9tica, \n    Optimizaci\xf3n energ\xe9tica, Asesoramiento el\xe9ctrico, Renovables, energ\xedas Renovables, eficiencia energ\xe9ticas,\n    consultor\xeda de software, asesoramiento de software, digitalizaci\xf3n, Ajuste de potencia, optimizaci\xf3n de potencia",
        content: "Encuentra las mejores tarifas de luz con el comparador m\xe1s preciso para tu negocio o vivienda y tramita totalmente online.",
        imageUrl: "https://res.cloudinary.com/dovplwabx/image/upload/v1709834393/Hero_1-modified_4_hby9it.png"
    };
    return /*#__PURE__*/ _jsxs(FivaLayout, {
        blue: true,
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(DynamicComponent, {
                news: data
            })
        ]
    });
};
export var __N_SSG = true;
export default _withSuperJSONPage(HomePage);
